import { createContext } from 'react';

export const ManifestContext = createContext({ manifest: null });
export const ManifestContextProvider = ManifestContext.Provider;
